import React, {useState, useCallback, useEffect, useContext} from 'react';
import DashboardMain_Bus from '../DashboardMain_Bus/DashboardMain_Bus';
import FilterSection from './FaultFirstPage/FilterSection';
// import '../Faultanalysis_Bus/FaultFirstPage_Bus/FaultFirstPageCustom_bus.css';
import '../Faultanalysis_BusNew/FaultFirstPage/FaultFirstPageCustom_bus.css';
import { decodeToken } from 'react-jwt';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus';
import KPISection from './FaultFirstPage/KPISection';
import DataBarSection from './FaultFirstPage/DataBarSection';
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import AppContext from '../../../store/AppContext';
import FaultSingleVinAnalysis from './FaultSingleVinAnalysis';
import FaultFirstGraph from './FaultFirstPage/FaultFirstGraph';
import FaultSecondGraph from './FaultFirstPage/FaultSecondGraph';

export default function FaultPage_BusNew() {
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    const city_name = decodedToken.city_name;
    const city_name_arr = city_name.split(",");
    const depo_name = decodedToken.depo_name;
    const depo_name_arr = depo_name.split(",");
    let sampleObj = (city_name !== "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE
  
    const [gloablfilter, setGloablfilter] = useState(sampleObj);
    const { isLoading, error, sendReq: fetchData } = useHttp();

    const app_ctx = useContext(AppContext);
    const log_data = (data) => {
    }

    useEffect(() => {
        fetchData({
          url: API_URL_MAIN + "auth/logging", body: {
            page_name: "faultanalysis_bus"
    
          }
        }, log_data)
      }, []);

    const filterSubmited = useCallback((data) => {
        setGloablfilter(data);
    }, []);

    const onreset = (data) => {
        setGloablfilter(data);
    }

    const singleVinSelected = (vin) => {
        let vin_num = vin.split(",");
        setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
    }

    const pageChange = () => {
      setGloablfilter((prevdata) => {
        return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
      });
    }

    if (gloablfilter.pageSelected === 1) {
        return (
          <>
            <DashboardMain_Bus>
                <FilterSection onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset}/>
                <div className="container-fluid busdrpg1">
                    <KPISection gloablfilter={gloablfilter} />
                    <section className="graphs sec2Charts">
                        <DataBarSection singleVinSelected={singleVinSelected} gloablfilter={gloablfilter} />
                        <div className="row mt-4 equal-cols">
                          <FaultFirstGraph gloablfilter={gloablfilter} />
                          <FaultSecondGraph gloablfilter={gloablfilter} />
                        </div>
                    </section>
                </div>
            </DashboardMain_Bus>
          </>
        );
      } else {
        return (
          <FaultSingleVinAnalysis gloablfilter={gloablfilter} pageChange={pageChange} />
        );
      }
}
